module.exports = __webpack_public_path__ + "static/media/logo.e4502410.png";